import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ActionType} from "@/util/type/store.ts";
import {CreateAuthConfigRequest} from "@/model/request/authConfig/CreateAuthConfigRequest.ts";
import {AuthConfigService} from "@/service/AuthConfigService.ts";
import {BaseResponse} from "@/model/response/BaseResponse.ts";

export type AuthConfigState = {
    loading: boolean;
};

const initialState: AuthConfigState = {
    loading: false,
};

const action = {
    create: createAsyncThunk(
        "authConfig/create",
        async (payload: ActionType<CreateAuthConfigRequest>, thunkAPI) => {
            return (await AuthConfigService.create(thunkAPI, payload.data)).data;
        }
    ),
};

const slice = createSlice({
    name: "authConfig",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        reset: () => ({...initialState})
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
                state.loading = true;
            }).addCase(action.create.fulfilled, (state, action) => {
            state.loading = false
            const response = action.payload as BaseResponse;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
    },
})

export const authConfig = {
    reducer: slice.reducer,
    action,
    mutation: slice.actions
}